<router-outlet></router-outlet>
<!-- <div fxLayout="column" fxLayoutAlign="start center" style="z-index: 500; background-color:#e8eaf6; height: 100%;">
    <p style="margin: 0px; font-size: 13px; text-align: center;
            color:rgb(63, 16, 1); font-family: sans-serif;">
        Copyright© Govt. of Meghalaya | Powered by xLayer Technologies Private Limited
    </p>
</div> -->